class PlAnnouncement extends HTMLElement {
  connectedCallback() {
    this.items = Array.from(this.querySelectorAll('[data-pl-msg]'));
    if (this.items.length < 2) return;
    const delay = parseInt(this.dataset.interval || '5000', 10);
    let i = 0;
    this.timer = setInterval(() => {
      this.items[i].classList.remove('is-active');
      i = (i + 1) % this.items.length;
      this.items[i].classList.add('is-active');
    }, delay);
  }

  disconnectedCallback() {
    if (this.timer) clearInterval(this.timer);
  }
}

if (!customElements.get('pl-announcement')) customElements.define('pl-announcement', PlAnnouncement);

class PlHeader extends HTMLElement {
  connectedCallback() {
    this.triggers = Array.from(this.querySelectorAll('[data-pl-menu-trigger]'));
    this.panels = Array.from(this.querySelectorAll('[data-pl-menu-panel]'));
    this.scrim = this.querySelector('[data-pl-scrim]');
    this.search = this.querySelector('[data-pl-search]');
    this.drawer = this.querySelector('[data-pl-drawer]');

    this.onGeometry = this.setGeometry.bind(this);
    window.addEventListener('scroll', this.onGeometry, { passive: true });
    window.addEventListener('resize', this.onGeometry);
    this.setGeometry();

    this.triggers.forEach((trigger) => {
      const key = trigger.dataset.plMenuTrigger;
      trigger.addEventListener('mouseenter', () => this.openMenu(key));
      trigger.addEventListener('focus', () => this.openMenu(key));
      trigger.addEventListener('click', (e) => {
        if (this.current === key) return;
        e.preventDefault();
        this.openMenu(key);
      });
    });

    this.panels.forEach((panel) => {
      panel.addEventListener('mouseleave', () => this.closeMenu());
    });

    const header = this.querySelector('[data-pl-header-bar]');
    if (header) header.addEventListener('mouseleave', (e) => {
      if (e.relatedTarget && e.relatedTarget.closest && e.relatedTarget.closest('[data-pl-menu-panel]')) return;
      this.closeMenu();
    });

    if (this.scrim) {
      this.scrim.addEventListener('mouseenter', () => this.closeMenu());
      this.scrim.addEventListener('click', () => this.closeMenu());
    }

    this.querySelectorAll('[data-pl-search-toggle]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        this.toggleSearch();
      });
    });

    this.querySelectorAll('[data-pl-drawer-toggle]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        this.toggleDrawer();
      });
    });

    this.querySelectorAll('[data-pl-drawer-close]').forEach((el) => {
      el.addEventListener('click', () => this.closeDrawer());
    });

    this.querySelectorAll('[data-pl-accordion]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const panel = btn.nextElementSibling;
        const open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (panel) panel.style.maxHeight = open ? null : panel.scrollHeight + 'px';
      });
    });

    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      this.closeMenu();
      this.closeSearch();
      this.closeDrawer();
    });
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onGeometry);
    window.removeEventListener('resize', this.onGeometry);
  }

  setGeometry() {
    const root = document.documentElement;
    const ann = document.querySelector('.pl-announcement-section');
    if (ann) {
      const sticky = getComputedStyle(ann).position === 'sticky';
      root.style.setProperty('--pl-ann-h', sticky ? ann.offsetHeight + 'px' : '0px');
    }
    const bar = this.querySelector('[data-pl-header-bar]');
    if (bar) {
      const bottom = Math.max(0, bar.getBoundingClientRect().bottom);
      root.style.setProperty('--pl-header-bottom', bottom + 'px');
    }
  }

  openMenu(key) {
    if (window.innerWidth <= 1054) return;
    this.current = key;
    this.panels.forEach((panel) => panel.classList.toggle('is-open', panel.dataset.plMenuPanel === key));
    this.triggers.forEach((trigger) => {
      trigger.setAttribute('aria-expanded', trigger.dataset.plMenuTrigger === key ? 'true' : 'false');
    });
    if (this.scrim) this.scrim.classList.add('is-open');
    this.classList.add('is-menu-open');
    this.closeSearch();
  }

  closeMenu() {
    this.current = null;
    this.panels.forEach((panel) => panel.classList.remove('is-open'));
    this.triggers.forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
    if (this.scrim) this.scrim.classList.remove('is-open');
    this.classList.remove('is-menu-open');
  }

  toggleSearch() {
    if (!this.search) return;
    if (this.search.hidden) {
      this.closeMenu();
      this.search.hidden = false;
      const input = this.search.querySelector('input[name="q"]');
      if (input) input.focus();
    } else {
      this.closeSearch();
    }
  }

  closeSearch() {
    if (this.search) this.search.hidden = true;
  }

  toggleDrawer() {
    if (!this.drawer) return;
    const open = this.drawer.classList.toggle('is-open');
    document.body.style.overflow = open ? 'hidden' : '';
  }

  closeDrawer() {
    if (!this.drawer) return;
    this.drawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }
}

if (!customElements.get('pl-header')) customElements.define('pl-header', PlHeader);

class PlFooter extends HTMLElement {
  connectedCallback() {
    Array.from(this.querySelectorAll('[data-pl-accordion]')).forEach((btn) => {
      btn.addEventListener('click', () => {
        if (window.innerWidth > 1054) return;
        const panel = btn.nextElementSibling;
        const open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (panel) panel.style.maxHeight = open ? null : panel.scrollHeight + 'px';
      });
    });

    this.form = this.querySelector('[data-pl-newsletter]');
    if (!this.form) return;
    this.tagsInput = this.form.querySelector('[data-pl-tags]');
    this.checks = Array.from(this.form.querySelectorAll('[data-pl-interest]'));
    if (!this.tagsInput || !this.checks.length) return;
    this.form.addEventListener('submit', () => {
      const picked = this.checks.filter((c) => c.checked).map((c) => c.value);
      this.tagsInput.value = picked.join(', ');
    });
  }
}

if (!customElements.get('pl-footer')) customElements.define('pl-footer', PlFooter);
